/**
 * Created by Jiu
 * Description:
 *
 * ---------maintenance history-------------
 * 2019.5.21 By Bowen Li: Hide Edit Dashboard button when the device is ipad
 * 2019.7.2 By Daniel: Add deleting layout function
 * 2019.7.3 By Bowen: Add add icon in livewire page for ppc user
 */
import { Component, OnInit, OnDestroy, ElementRef, ViewChild, HostListener } from '@angular/core';
import { Subscription } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { DeviceDetectorService } from 'ngx-device-detector';

import { AppState } from '../../redux';
import { SaveScreenDialogService } from '../save-screen-dialog/save-screen-dialog.service';
import { SaveScreenDialogOperations, SaveScreenDialogType, SaveScreenDialogInvoker } from '../save-screen-dialog/save-screen-dialog.view-model';
import { ResearchViewInfo, FilterInfo, GridColumnInfo } from '../../pages/research/research.view-model';
import { StoreQuerierService } from '../../services/store-querier.service';

import { SavedScreen } from '../../tamalelibs/models/saved-screen.model';
import { FiltersConfig } from '../../tamalelibs/components/filter-config';
import { ScreenService } from '../../tamalelibs/services/screen.service';
import {
    getDynamicResearchFocusSelector2, getDynamicResearchRelationshipTreeCheckedKeysSelector2,
    getDynamicResearchSortInfoSelector2, getDynamicResearchLayoutSelector2, getDynamicResearchFilterItemsSelector2,
    getDynamicResearchFilterEnableSelector2, getDynamicResearchFilterLogicSelector2, getDynamicResearchGridStatusSelector2,
    researchChangeStatusSelector, getDynamicResearchKeywordSelector2, getDynamicResearchRefinebyCategorySelector,
    getDynamicResearchRelationshipSelector2,
    getDynamicResearchDisplaySelector2,
    getDynamicResearchThreadListGridGropLayoutSelector
} from '../../redux/reducers/research-screen.reducer';
import { getHomeScreenSelector } from '../../redux/reducers/home-screen.reducer';
import { SystemUser } from '../../tamalelibs/models/user.model';
import { Router } from '@angular/router';
import { lastActionSelector, lastCustomActionSelector } from '../../redux/reducers/action-history.reducer';
import { SystemActionTypes } from '../../tamalelibs/redux/actions/system.actions';
import { ResearchScreenActionTypes } from '../../redux/actions/research-screen.actions';
import { ContextMenuConfig, ContextMenuShowAction } from '../../widgets/tam-context-menu/tam-context-menu.model';
import { HomeScreenActionTypes } from '../../redux/actions/home-screen.actions';
import { businessConstants } from '../../constants/business.constants';
import { HomeScreenTab, HomeScreenType, HomeScreenConfig } from '../../pages/home-screen/home-screen.model';
import { HomeScreenService } from '../../services/home-screen.service';
import { ToastService } from '../../widgets/toast/toast.service';
import { NotificationStyles } from '../../widgets/notification/notification.model';
import { take, filter } from 'rxjs/operators';
import { SubChromeActionTypes } from '../../redux/actions/sub-chrome-name.action';
import { AlertButton, AlertBtnTypes } from '../../widgets/alert-window/alert-window.model';
import { AlertWindowService } from '../../widgets/alert-window/alert-window.service';
import { FileHelperService } from '../../services/file-helper.service';
import { ScreenActionTypes } from '../../redux/actions/screen.actions';
import { UsersActionTypes } from '../../redux/actions/users.actions';
import { ArrayHelperService } from '../../tamalelibs/services/array-helper.service';
import { AdminPagesService } from '../../tamalelibs/services/admin-page.service';

@Component({
    selector: 'sub-chrome',
    templateUrl: './sub-chrome.component.html',
    styleUrls: ['./sub-chrome.component.scss']
})
export class SubChromeComponent implements OnInit, OnDestroy {
    @ViewChild('livewireNameInput', { static: false }) livewireNameInput: ElementRef;

    btnName = 'Save';
    currentPageInfo: any;
    currentViewName: string;
    keyOfScreen = 'researchView';
    isHomeScreen = false;
    isEdit = false;
    isHasPermission = false;
    isUsageReport = false;
    isIPAD = false;
    isPPCUser = false;
    layoutsContextMenuConfig: ContextMenuConfig;
    operationContextMenuConfig: ContextMenuConfig;
    showOperationBox = false;
    showSaveButton = false;
    viewNameColor = true;

    private _currentUser: SystemUser;
    private _destroySubscriptions: Array<Subscription> = [];
    private _downloadFile = false;
    private _homeScreens = [];

    constructor(
        private _alertWindow: AlertWindowService,
        private _adminPageService: AdminPagesService,
        private _deviceService: DeviceDetectorService,
        private _fileHelperService: FileHelperService,
        private _homeScreenService: HomeScreenService,
        private _router: Router,
        private _saveScreenDialogService: SaveScreenDialogService,
        private _screenService: ScreenService,
        private _store: Store<AppState>,
        private _storeQuerier: StoreQuerierService,
        private _toast: ToastService,
    ) {
        this.isIPAD = this._deviceService.isMobile() || this._deviceService.isTablet();
    }

    ngOnInit() {
        this._currentUser = this._storeQuerier.getCurrentUser();
        this.isPPCUser = this._currentUser.credential.publishPubConfiguration;

        this._initLayoutsConfigContextMenu();
        this._initOperationConfigContextMenu();

        this._destroySubscriptions.push(
            this._store.pipe(
                select('screenInfo')
            ).subscribe(screenInfo => this._screenChangeHandler(screenInfo)),
            this._store.pipe(
                select(lastActionSelector)
            ).subscribe(action => this._onSubscribeActionMessage(action)),
            this._store.pipe(
                select(lastCustomActionSelector)
            ).subscribe(action => this._actionMessageHandler(action)),
            this._store.pipe(
                select(researchChangeStatusSelector)
            ).subscribe(researchStatus => {
                if (researchStatus) {
                    this._onSubscribeResearchChangeStatus(researchStatus);
                }
            }),
            this._store.pipe(
                select(getHomeScreenSelector)
            ).subscribe(res => this._onSubscribeHomeScreens(res)),

            this._fileHelperService.downloadFile$.subscribe(() => {
                this._downloadFile = true;
            })
        );
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(subscription => subscription.unsubscribe());
    }

    // TODO this may need refactor, use Guard instead of HostListener
    @HostListener('window:beforeunload', ['$event'])
    unloadNotification($event: any) {
        if (this.showSaveButton && this.btnName === 'Save' && !this._downloadFile) {
            $event.returnValue = true;
        }
        this._downloadFile = false;
    }

    changeLivewireName(currentLivewireName: string) {
        if (!currentLivewireName) {
            this.currentViewName = 'Livewire';
        } else {
            this.currentViewName = currentLivewireName;
        }
        this._store.dispatch({
            type: SubChromeActionTypes.CHANGE_LIVEWIRE_SUBCHORME_NAME,
            payload: this.currentViewName
        });
    }

    // when input blur, the input will hide
    disableChangeLivewireName(currentViewName: string) {
        if (this.currentPageInfo.type === 'CREATE_BLASTEMAIL') {
            this.isEdit = false;
            this.changeLivewireName(currentViewName);
        }
    }

    exportToExcel() {
        this._adminPageService.exportToExcel$.next();
    }

    // press enter to change livewire name
    keypressForChangeLivewireName(event) {
        if (event.keyCode === 13 && this.currentPageInfo.type === 'CREATE_BLASTEMAIL') {
            this.isEdit = false;
            this.changeLivewireName(event.srcElement.value);
        }
    }

    onChangeLivewireName() {
        if (this.currentPageInfo.type === 'CREATE_BLASTEMAIL') {
            this.isEdit = true;
            setTimeout(() => {
                this.livewireNameInput.nativeElement.focus();
            }, 0);
        }
    }

    onSaveClick() {
        if (this.currentPageInfo.type === 'SAVED_RESEARCH') {
            this._screenService.getById(this.currentPageInfo.id).subscribe(screen => {
                const screenData = new SavedScreen();
                screenData.id = screen.id;
                screenData.name = screen.name;
                screenData.description = screen.description;
                screenData.isPublic = screen.isPublic;
                screenData.accessList = screen.accessList;
                screenData.configuration = this._generateResearchViewInfo();

                this._screenService.update(screenData).pipe(
                    take(1)
                ).subscribe(response => this._saveSuccessHandler(response), () => this._failedHandler(screen.name));
            });
        } else if (this.currentPageInfo.type === 'HOME_SCREEN') {
            const content: string[] = [];
            content.push('Are you sure you want to publish this layout ?', this.currentPageInfo.name);
            const cancelBtn: AlertButton = {
                text: 'Cancel',
                type: AlertBtnTypes.tertiary
            };
            const confirmButton: AlertButton = {
                text: 'Publish',
                type: AlertBtnTypes.primary
            };
            const subscription = this._alertWindow.
                custom('Publish layout confirmation required', content, cancelBtn, confirmButton)
                .subscribe((result: boolean) => {
                    if (result) {
                        this._homeScreenService.getHomeScreenLayoutById(this.currentPageInfo.id).subscribe(layout => {
                            const homeScreenInfo = new HomeScreenConfig();
                            homeScreenInfo.id = layout.id;
                            homeScreenInfo.name = layout.name;
                            homeScreenInfo.description = layout.description;
                            homeScreenInfo.isPublic = layout.isPublic;
                            homeScreenInfo.accessList = layout.accessList;
                            homeScreenInfo.type = HomeScreenType.HomeScreen;
                            homeScreenInfo.tabs = layout.tabs;
                            this._homeScreenService.updateOriginalHomeScreen(homeScreenInfo).subscribe(response => this._sharedSuccessHandler(response), response => this._failedHandler(response));
                        });
                    }
                    subscription.unsubscribe();
                });
        } else if (this.currentPageInfo.type === 'DASHBOARD') {
            this._router.navigate(['dashboard/edit', this.currentPageInfo.id]);
        }
    }

    onLayoutsMenuSelect(event) {
        if (event.payload) {
            this._store.dispatch({
                type: HomeScreenActionTypes.CHANGE_LAYOUT,
                payload: event.payload.id
            });
            this._store.dispatch({ type: ScreenActionTypes.SCREEN_STATUS_DICTIONARY_CLEAR });
        }
    }

    onLayoutsShowContextMenu(e: MouseEvent) {
        if (this.isHomeScreen) {
            this.layoutsContextMenuConfig.show$.next(new ContextMenuShowAction(e, ''));
        }
    }

    onOperationShowContextMenu(e: MouseEvent) {
        this.operationContextMenuConfig.show$.next(new ContextMenuShowAction(e, ''));
    }

    private _actionMessageHandler(action) {
        if (action.type === SystemActionTypes.EDIT_SCREEN) {
            if (action.payload && action.payload.type) {
                if (action.payload.type !== businessConstants.screenType.workflow) {
                    this.currentViewName = action.payload.name;
                    this.showSaveButton = false;
                }
            } else {
                this.currentViewName = action.payload.name;
                this.showSaveButton = false;
            }
        } else if (action.type === SubChromeActionTypes.CHANGE_LIVEWIRE_SUBCHORME_NAME_FAILED) {
            // show old value when request failed
            this._store.dispatch({
                type: SubChromeActionTypes.GET_LIVEWIRE_SUBCHORME_NAME
            });
        }
    }

    private _failedHandler(screenName) {
        this._toast.notify({
            message: `${screenName} saved failed.`,
            style: NotificationStyles.Error
        });
    }

    private _generateNewHomeScreenLayoutInfo() {
        const homeScreenData = new HomeScreenConfig();
        const newHomeScreenId = 'NewHomeScreenID';
        const newHomeScreenName = '';
        const allNotesTab = new HomeScreenTab(businessConstants.allNotes.id,
            businessConstants.allNotes.name,
            businessConstants.allNotes.screenId,
            businessConstants.allNotes.screenType,
            businessConstants.allNotes.type,
            businessConstants.allNotes.editable);
        const myNotesTab = new HomeScreenTab(businessConstants.myNotes.id,
            businessConstants.myNotes.name,
            businessConstants.myNotes.screenId,
            businessConstants.myNotes.screenType,
            businessConstants.myNotes.type,
            businessConstants.myNotes.editable);
        const pages = [allNotesTab, myNotesTab];

        homeScreenData.id = newHomeScreenId;
        homeScreenData.name = newHomeScreenName;
        homeScreenData.description = '';
        homeScreenData.isPublic = false;
        homeScreenData.tabs = pages;
        homeScreenData.type = HomeScreenType.HomeScreen;
        homeScreenData.accessList = [this._currentUser.id];
        return homeScreenData;
    }

    private _generateResearchViewInfo() {
        const researchViewInfo = new ResearchViewInfo();
        const finderInfo = this._storeQuerier.queryBySelector(getDynamicResearchFocusSelector2(this.keyOfScreen));
        researchViewInfo.finderInfo = {
            entityId: finderInfo.entity.id,
            status: finderInfo.status
        };
        const refinebyInfo: Array<string> =
            this._storeQuerier.queryBySelector(getDynamicResearchRefinebyCategorySelector(this.keyOfScreen));
        if (refinebyInfo) {
            researchViewInfo.refineByInfo.category.push(...refinebyInfo);
        }
        const checkedKeys: string[] =
            this._storeQuerier.queryBySelector(getDynamicResearchRelationshipTreeCheckedKeysSelector2(this.keyOfScreen));
        const showAsName = this._storeQuerier.queryBySelector(getDynamicResearchRelationshipSelector2(this.keyOfScreen)).showAs;
        // filter checked keys; remove all leaf nodes if their parent node is checked;
        checkedKeys.sort();
        const checkedKeysAfterFilter = [];
        checkedKeys.forEach((key: string) => {
            let ignore = false;
            for (const key1 of checkedKeysAfterFilter) {
                if (key.includes(key1)) {
                    ignore = true;
                    break;
                }
            }
            if (!ignore) {
                checkedKeysAfterFilter.push(key);
            }
        });
        researchViewInfo.relationshipTreeInfo = {
            showAs: showAsName,
            checkedNodeKeys: checkedKeysAfterFilter
        };
        const sortInfo = this._storeQuerier.queryBySelector(getDynamicResearchSortInfoSelector2(this.keyOfScreen));
        researchViewInfo.sortInfo = sortInfo;

        const layoutInfo = this._storeQuerier.queryBySelector(getDynamicResearchLayoutSelector2(this.keyOfScreen));
        researchViewInfo.layoutInfo = layoutInfo;

        researchViewInfo.filterInfo = new FilterInfo();
        const filterConfigs: FiltersConfig[] = this._storeQuerier.queryBySelector(getDynamicResearchFilterItemsSelector2(this.keyOfScreen));
        researchViewInfo.filterInfo.isFilterOn =
            this._storeQuerier.queryBySelector(getDynamicResearchFilterEnableSelector2(this.keyOfScreen));
        researchViewInfo.filterInfo.filterLogic =
            this._storeQuerier.queryBySelector(getDynamicResearchFilterLogicSelector2(this.keyOfScreen));
        researchViewInfo.filterInfo.filterConfigs = filterConfigs.map(config => {
            const tempConfig = Object.assign({}, config);
            if (tempConfig.hasOwnProperty('operators')) {
                delete tempConfig.operators;
            }
            if (tempConfig.hasOwnProperty('source')) {
                delete tempConfig.source;
            }
            if (tempConfig.hasOwnProperty('relationshipTypeSource')) {
                delete tempConfig.relationshipTypeSource;
            }
            return tempConfig;
        });
        const gridColumnInfo: GridColumnInfo[] =
            this._storeQuerier.queryBySelector(getDynamicResearchGridStatusSelector2(this.keyOfScreen));
        researchViewInfo.gridColumnInfo = gridColumnInfo;

        researchViewInfo.keywordInfo = this._storeQuerier.queryBySelector(getDynamicResearchKeywordSelector2(this.keyOfScreen));

        // display info
        const displayInfo = this._storeQuerier.queryBySelector(getDynamicResearchDisplaySelector2(this.keyOfScreen));
        researchViewInfo.displayInfo = displayInfo;

        const gridGroupLayout = this._storeQuerier.queryBySelector(getDynamicResearchThreadListGridGropLayoutSelector(this.keyOfScreen));
        researchViewInfo.gridGroupLayout = gridGroupLayout;
        return researchViewInfo;
    }

    private _initLayoutsConfigContextMenu() {
        this.layoutsContextMenuConfig = new ContextMenuConfig();
        this.layoutsContextMenuConfig.stateful = false;
        this.layoutsContextMenuConfig.showItemIcon = false;
        this.layoutsContextMenuConfig.clickOnDiv = false;
        const homeScreens = this._storeQuerier.queryBySelector(getHomeScreenSelector);
        if (homeScreens instanceof Array) {
            homeScreens.forEach(item => {
                const homeScreen = {
                    id: item.id,
                    text: item.name
                };
                this._homeScreens.push(homeScreen);
            });
        }
        this.layoutsContextMenuConfig.items = this._homeScreens;
        this.layoutsContextMenuConfig.events$.subscribe(event => this.onLayoutsMenuSelect(event));
    }

    private _initOperationConfigContextMenu() {
        this.operationContextMenuConfig = new ContextMenuConfig();
        this.operationContextMenuConfig.stateful = false;
        this.operationContextMenuConfig.showItemIcon = false;
        this.operationContextMenuConfig.clickOnDiv = false;
        this.operationContextMenuConfig.items = [
            { id: '0', text: 'Create New Layout' },
            { id: '1', text: 'Edit Detail' },
            { id: '2', text: 'Delete Layout' },
            { id: '3', text: 'Set as my default layout' },
        ];
        this.operationContextMenuConfig.events$.subscribe(event => this._onOperationMenuSelect(event));
    }

    private _onOperationMenuSelect(event) {
        if (event.payload) {
            const id = event.payload.id;
            if (this.currentPageInfo.type === SaveScreenDialogInvoker.HOME_SCREEN) {
                if (id === '0') {
                    this._saveScreenDialogService.open({
                        operation: SaveScreenDialogOperations.CREATE,
                        type: SaveScreenDialogType.HOME_SCREEN,
                        data: this._generateNewHomeScreenLayoutInfo(),
                        invoker: SaveScreenDialogInvoker.HOME_SCREEN
                    });
                } else if (id === '1') {
                    this._homeScreenService.getHomeScreenLayoutById(this.currentPageInfo.id).subscribe(screen => {
                        const homeScreenData = new HomeScreenConfig();
                        homeScreenData.id = screen.id;
                        homeScreenData.name = screen.name;
                        homeScreenData.description = screen.description;
                        homeScreenData.isPublic = screen.isPublic;
                        homeScreenData.accessList = screen.accessList;
                        homeScreenData.type = HomeScreenType.HomeScreen;
                        homeScreenData.tabs = screen.tabs;
                        this._saveScreenDialogService.open({
                            operation: SaveScreenDialogOperations.EDIT,
                            type: SaveScreenDialogType.HOME_SCREEN,
                            data: homeScreenData,
                            invoker: SaveScreenDialogInvoker.HOME_SCREEN
                        });
                    });
                } else if (id === '2') {
                    const cancelBtn: AlertButton = {
                        text: 'Cancel',
                        type: AlertBtnTypes.tertiary
                    };
                    const confirmButton: AlertButton = {
                        text: 'Delete',
                        type: AlertBtnTypes.destructive
                    };
                    const subscription = this._alertWindow.
                        custom('Delete confirmation required', ['Are you sure you want to delete this layout ?',
                            this.currentPageInfo.name], cancelBtn, confirmButton)
                        .subscribe((result: boolean) => {
                            if (result) {
                                this._store.dispatch({
                                    type: HomeScreenActionTypes.DELETE,
                                    payload: this.currentPageInfo.id
                                });
                            }
                            subscription.unsubscribe();
                        });
                } else if (id === '3') {
                    this._setDefaultLayout();
                }
            } else {
                if (id === '0') {
                    this._screenService.getById(this.currentPageInfo.id).subscribe(screen => {
                        const screenData = new SavedScreen();
                        screenData.id = screen.id;
                        screenData.name = screen.name;
                        screenData.description = screen.description;
                        screenData.isPublic = screen.isPublic;
                        screenData.accessList = screen.accessList;
                        screenData.configuration = this._generateResearchViewInfo();

                        this._saveScreenDialogService.open({
                            operation: SaveScreenDialogOperations.EDIT,
                            type: SaveScreenDialogType.RESEARCH_VIEW,
                            data: screenData,
                            invoker: SaveScreenDialogInvoker.SAVED_RESEARCH
                        });
                    });
                }
            }
        }
    }

    private _onSubscribeHomeScreens(res) {
        if (res && res.data.length > 0) {
            const homeScreens = res.data;
            if (homeScreens instanceof Array) {
                this._homeScreens = [];
                homeScreens.forEach(item => {
                    const homeScreen = {
                        id: item.id,
                        text: item.name
                    };
                    this._homeScreens.push(homeScreen);
                });
                this.layoutsContextMenuConfig.items = this._homeScreens;
            }
        }
    }

    private _onSubscribeActionMessage(action) {
        if (action === SystemActionTypes.ADD_SCREEN) {
            this.viewNameColor = false;
            this.showSaveButton = true;
        }
    }

    private _onSubscribeResearchChangeStatus(status) {
        if (status.type === ResearchScreenActionTypes.SET_SAVE_SCREEN_CHANGE_STATUS && status.payload) {
            // PPC user will have ability to change the save screen if s/he is able to access that screen
            // PPC + Compliance would be able to change / update any saved screen
            if (this._currentUser) {
                if (this._currentUser.credential.publishPubConfiguration) {
                    this.showSaveButton = true;
                } else if (this.currentPageInfo && this.currentPageInfo.id) {
                    // Normal user will only able to update / change the existing saved screen that created by himself
                    this._screenService.getById(this.currentPageInfo.id).pipe(take(1)).subscribe(res => {
                        if (this._currentUser.id === res.author['id']) {
                            this.showSaveButton = true;
                        } else {
                            this.showSaveButton = false;
                        }
                    });
                }
            }
        }
    }

    private _screenChangeHandler(screenInfo) {
        this.currentPageInfo = screenInfo;
        this.currentViewName = screenInfo.name;
        this.isHomeScreen = false;
        this.showOperationBox = false;
        this.isHasPermission = false;
        this.isUsageReport = false;
        if (this.currentPageInfo.type === 'CREATE_RESEARCH') {
            this.btnName = 'Save';
            this.viewNameColor = true;
            this.showOperationBox = true;
            this.showSaveButton = true;
            this._setSavedScreenPermssion();
            this.operationContextMenuConfig.items = [
                { id: '0', text: 'Edit Detail' },
            ];
        } else if (this.currentPageInfo.type === 'SAVED_RESEARCH') {
            this.viewNameColor = false;
            this.showOperationBox = true;
            this.showSaveButton = false;
            this.btnName = 'Save';
            this._setSavedScreenPermssion();
            this.operationContextMenuConfig.items = [
                { id: '0', text: 'Edit Detail' },
            ];
        } else if (this.currentPageInfo.type === 'HOME_SCREEN') {
            this.viewNameColor = false;
            this.isHomeScreen = true;
            this.showOperationBox = true;
            this.isHasPermission = true;
            const isPPCUser = this._currentUser && this._currentUser.credential.publishPubConfiguration;
            if (isPPCUser) {
                this.showSaveButton = this.currentPageInfo.id !== businessConstants.defaultHomeScreenId;
            }
            this.btnName = 'Publish';
            // change the menu item name
            if (this._homeScreens) {
                this._homeScreens.forEach(homescreen => {
                    if (homescreen.id === screenInfo.id) {
                        homescreen.text = screenInfo.name;
                    }
                });
                ArrayHelperService.sort(this._homeScreens, 'text');
                this.layoutsContextMenuConfig.items = this._homeScreens;
            }
            if (isPPCUser) {
                if (this.currentPageInfo.id === businessConstants.defaultHomeScreenId) {
                    this.operationContextMenuConfig.items = [
                        { id: '0', text: 'Create New Layout' },
                        { id: '3', text: 'Set as my default layout' },
                    ];
                } else {
                    this.operationContextMenuConfig.items = [
                        { id: '0', text: 'Create New Layout' },
                        { id: '1', text: 'Edit Detail' },
                        { id: '2', text: 'Delete Layout' },
                        { id: '3', text: 'Set as my default layout' },
                    ];
                }
            } else {
                this.operationContextMenuConfig.items = [
                    { id: '3', text: 'Set as my default layout' },
                ];
            }
        } else if (this.currentPageInfo.type === 'CREATE_BLASTEMAIL') {
            // to change the livewire name
            this._destroySubscriptions.push(
                this._store.pipe(
                    select('subChromeName'),
                    filter(item => item),
                ).subscribe(value => this.currentViewName = value),
            );
            this.showOperationBox = false;
        } else if (this.currentPageInfo.type === 'USAGE_REPORT') {
            this.showOperationBox = true;
            this.isUsageReport = true;
        } else {
            this.viewNameColor = false;
            this.showOperationBox = false;
        }
    }

    private _setSavedScreenPermssion() {
        // set meatball permission when page is changed.
        this.isHasPermission = false;
        if (this._currentUser) {
            if (this._currentUser.credential.publishPubConfiguration) {
                this.isHasPermission = true;
            } else if (this.currentPageInfo && this.currentPageInfo.id) {
                // Normal user will only able to update / change the existing saved screen that created by himself
                this._screenService.getById(this.currentPageInfo.id).subscribe(res => {
                    if (this._currentUser.id === res.author['id']) {
                        this.isHasPermission = true;
                    } else {
                        this.isHasPermission = false;
                    }
                });
            }
        }
    }

    private _saveSuccessHandler(response) {
        this.showSaveButton = false;
        this._store.dispatch({ type: ScreenActionTypes.SCREEN_DICTIONARY, payload: response });
        this._toast.notify({
            message: `${response.name} successfully updated.`,
            style: NotificationStyles.Success
        });
    }

    private _sharedSuccessHandler(response) {
        this._store.dispatch({ type: ScreenActionTypes.SCREEN_STATUS_DICTIONARY_CLEAR });
        this._toast.notify({
            message: `${response.name} layout successfully shared.`,
            style: NotificationStyles.Success
        });
    }

    private _setDefaultLayout() {
        const config = {
            defaultHomeLayout: {
                id: this.currentPageInfo.id
            }
        };
        this._store.dispatch({
            type: UsersActionTypes.UPDATE_USER_SETTING,
            payload: config
        });
        this._store.pipe(
            select(lastCustomActionSelector),
            filter(action => action.type === UsersActionTypes.UPDATE_USER_SETTING_SUCCESS),
            take(1)
        ).subscribe(() => {
            this._toast.notify({
                message: `Set ${this.currentPageInfo.name} as default layout successfully`,
                style: NotificationStyles.Success
            });
        });
    }
}
